import React, { useRef } from 'react';

type SwitchProps = {
  checked?: boolean;
  description?: string;
  disabled?: boolean;
  label?: string | React.ReactNode;
  labelPosition?: 'before' | 'after';
  onChange?: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  value?: string;
};

const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  (
    {
      checked = false,
      description = '',
      disabled = false,
      label = '',
      labelPosition = 'after',
      onChange = () => {},
      value,
      ...props
    },
    ref
  ) => {
    const descriptionIdRef = useRef<string>();
    if (description && !descriptionIdRef.current) {
      descriptionIdRef.current = `switch-desc-${Math.random().toString(36).slice(2, 9)}`;
    }
    const descriptionId = description ? descriptionIdRef.current : undefined;

    function handleChange(e: React.ChangeEvent<HTMLInputElement>): void {
      onChange(e, e.target.checked);
    }

    return (
      <label className={`switch switch--label-${labelPosition}`}>
        <input
          {...props}
          ref={ref}
          checked={checked}
          className="switch__input"
          disabled={disabled}
          onChange={handleChange}
          role="switch"
          type="checkbox"
          value={value}
          {...(descriptionId ? { 'aria-describedby': descriptionId } : {})}
        />
        <span className="switch__track" aria-hidden="true" />
        {(label || description) && (
          <div className="switch__texts">
            {label && (
              <span title={typeof label === 'string' ? label : undefined} className="switch__label">
                {label}
              </span>
            )}
            {description && (
              <span id={descriptionId} title={description} className="switch__description">
                {description}
              </span>
            )}
          </div>
        )}
      </label>
    );
  }
);

Switch.displayName = 'Switch';

export default Switch;
